export enum OFFER_CURRENCY {
  USD = 'USD',
  CAD = 'CAD',
  BBD = 'BBD',
}
